<template>
  <div class="mt-3" v-if="config.length">
    <!-- Category-->
    <div></div>
    <div
      v-for="(section, i) in config"
      :key="`section-${i}`"
      class="form-card-wrapper"
    >
      <b-card :header="section.category" header-tag="header">
        <!-- Section Overlay -->
        <b-overlay center :show="section.isLoading" rounded="sm">
          <!-- Upload Fields -->
          <b-card-text
            class="import-outer-card"
            v-for="(upload, j) in section.upload"
            :key="`upload-${j}`"
          >
            <p
              class="btn btn--smaller btn--transparent import-line"
              v-b-toggle="`${section.type}-${j}`"
              variant="primary"
            >
              {{ upload.title }}
            </p>
            <b-collapse :id="`${section.type}-${j}`">
              <!-- File -->
              <div class="mt-3 mb-3">
                <b-card
                  v-for="(file, k) in upload.files"
                  :key="`files-${section.type}-${k}`"
                  class="import-inner-card"
                >
                  <!-- File Overlay -->
                  <b-overlay center :show="file.isLoading" rounded="sm">
                    <b-card-text>
                      <b-table
                        :fields="fields"
                        :items="[file]"
                        :data-id="`importerInnerTable-files-${section.type}-${k}`"
                      >
                        <template #cell(title)="data">
                          {{ data.item.import_file_code }}
                        </template>
                        <template #cell(filesystem)="data">
                          <div class="">
                            <base-form-file
                              v-model="data.item.value"
                              vid="base_form_file"
                              :accept="fileAccept(data.item.import_file_code)"
                              :disabled="data.item.isStored"
                            ></base-form-file>
                          </div>
                        </template>
                        <template #cell(upload)="data">
                          <b-button
                            class="btn btn--create btn--smaller"
                            type="button"
                            variant="lisaweb"
                            size="sm"
                            data-type="special-btn"
                            @click="uploadFile(data, upload)"
                            :disabled="data.item.isStored || !data.item.value"
                            title="Carica File"
                          >
                            Carica
                          </b-button>
                        </template>
                        <template #cell(delete)="data">
                          <b-button
                            variant="outline-danger"
                            class="btn--light btn--alert"
                            style="border-radius: 50% !important"
                            size="sm"
                            @click="deleteFile(data)"
                            :disabled="!data.item.isStored"
                            title="Elimina file caricato"
                          >
                            <base-icon name="trash"></base-icon>
                          </b-button>
                        </template>
                        <template #cell(check)="data">
                          <b-icon
                            icon="check-square"
                            scale="2"
                            variant="success"
                            title="File caricato"
                            v-if="data.item.isStored"
                          >
                          </b-icon>
                          <b-icon
                            icon="x-circle"
                            scale="2"
                            variant="warning"
                            title="File non caricato"
                            v-if="!data.item.isStored"
                          >
                          </b-icon>
                        </template>
                      </b-table>
                    </b-card-text>

                    <template #overlay>
                      <div class="text-center">
                        <div class="custom-loader"></div>
                        <p class="loading-text">Operazione in corso...</p>
                      </div>
                    </template>
                  </b-overlay>
                </b-card>
              </div>
              <b-button
                class="btn btn--create btn--smaller mt-2"
                type="button"
                variant="lisaweb"
                size="sm"
                title="Inizia Trasmissione"
                @click="init(section, upload)"
                :disabled="!checkStoredFiles(upload)"
              >
                Inizia Trasmissione
              </b-button>
            </b-collapse>
          </b-card-text>
          <template #overlay>
            <div class="text-center">
              <div class="custom-loader"></div>
              <p class="loading-text">Operazione in corso...</p>
            </div>
          </template>
        </b-overlay>
      </b-card>
    </div>
  </div>
  <div class="mt-3" v-else-if="!isLoading">
    <div class="form-card-wrapper">
      <b-card>
        <p
          style="font-size: 14px; font-weight: 500; text-align: center"
          class="mt-4 mb-4"
        >
          Non ci sono file da importare
        </p>
      </b-card>
    </div>
  </div>
</template>

<script>
import BaseIcon from "@/components/BaseIcon";
import BaseFormFile from "@/components/form/BaseFormFile";

export default {
  props: {
    config: {
      default() {
        return [];
      },
      type: Array,
    },
    isLoading: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      fields: [
        {
          key: "title",
          thStyle: {
            display: "none",
          },
          tdClass: "col-sm-2",
        },
        {
          key: "filesystem",
          thStyle: {
            display: "none",
          },
          tdClass: "col-md-2",
        },
        {
          key: "upload",
          thStyle: {
            display: "none",
          },
          tdClass: "col-md-1",
        },
        {
          key: "delete",
          thStyle: {
            display: "none",
          },
          tdClass: "col-md-1",
        },
        {
          key: "check",
          thStyle: {
            display: "none",
          },
          tdClass: "col-md-1",
        },
      ],
      form: {
        file: null,
      },
    };
  },
  components: {
    BaseIcon,
    BaseFormFile,
  },
  methods: {
    // Filtra la selezione dei file sull’estensione del file richiesto
    fileAccept(importFileCode) {
      const match = String(importFileCode || "")
        .trim()
        .toLowerCase()
        .match(/(\.[^.]+)$/);
      return match ? match[1] : undefined;
    },
    uploadFile(file, section) {
      this.$emit("upload", file, section);
    },
    deleteFile(file) {
      this.$emit("delete", file);
    },
    init(section, upload) {
      this.$emit("init", section, upload);
    },
    checkStoredFiles(upload) {
      let fileStatuses = [];
      upload.files.forEach((file) => {
        fileStatuses.push(file.isStored);
      });
      return fileStatuses.every((status) => status);
    },
  },
};
</script>

<style scoped lang="scss">
:deep(.table) {
  margin: 0;
  tr {
    background: 0 !important;
  }
  td {
    background: 0 !important;
    border-top: 0 !important;
  }
  th {
    border-top: 0 !important;
  }
  .form-group {
    margin: 0;
  }
  .btn--alert {
    width: 2rem;
    height: 2rem;
    padding: 0 4px;
  }
  .btn[data-type="special-btn"] {
    height: 2rem;
  }
  .custom-file-label {
    margin: 0 !important;
  }
}
.form-card-wrapper {
  .card-body {
    padding-block: 0 !important;
  }
}
.import-line {
  max-width: max-content;
  margin: 0;
}
.import-inner-card {
  border: 0;
  border-radius: 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}
.import-outer-card {
  &:first-of-type {
    margin-top: 1.5rem;
  }
  &:last-of-type {
    margin-bottom: 1.5rem;
  }
}
.import-outer-card ~ .import-outer-card {
  margin-top: 1rem;
  border-top: 1px solid rgba(0, 0, 0, 0.125);
  padding-top: 1rem;
}
</style>
<style lang="scss">
body {
  .main-content {
    .table[data-id^="importerInnerTable-files"] {
      max-width: 1100px;
      tbody {
        tr:hover:not(.b-table-empty-row) {
          td {
            background: 0 !important;
          }
        }
        // .bi.text-warning {
        //   color: #ff9307 !important;
        // }
      }
    }
  }
}
</style>
